<div *ngIf="productList.length != 0" class="cart-column-spacing stock-listing back-in-stock blue-bg">
    <h3 class="d-none d-lg-flex" accordion-heading>Back In Stock<span class="product-count">{{totalProductCount}} Products</span></h3>
    <div class="product-grid infinite-responsive scrollbar d-none d-lg-flex p-0" *ngIf="!noRecord" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false" [horizontal]="true">
        <div class="product-wrapper" id="product_{{product.product_id}}" *ngFor="let product of productList">
            <ul class="product-type" *ngIf="product.price_marked == 1">
                <li>
                    <img
                            src="../../assets/images/pmp.svg" alt="checked icon" />
                </li>
            </ul>
            <div class="product-inner-wrapper">
                <div class="product-image">
                    <a [routerLink]="['/product/detail',product.sku]">
                        <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                    </a>
                </div>
                <div class="product-description">
                    <h2>{{product.short_desc}}</h2>
                    <div class="add-cart-wrapper add_btn_{{product.product_id}}" ng-app="classApp" [ngClass]="product.item_id !== '' ? 'expand' : 'no-expand'" *ngIf="product.item_id == ''">
                        <div id="spinner_{{product.product_id}}" class="spinner">
                            <ngx-number-spinner id="spinerbtn_{{product.product_id}}" [ngClass]="{'spinner':true}" [value]="product.qty !='' ? toInteger(product.qty) : 1" [min]="1" (change)="qytChange(product, $event)">
                            </ngx-number-spinner>
                        </div>
                        <button [ngClass]="{'btn primary-btn':true}" id="btn_{{product.product_id}}" *ngIf="product.item_id == ''" (click)="addToCart(product, product.qty)">Add</button>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <div class="product-grid infinite-responsive scroll-body d-flex d-lg-none" *ngIf="!noRecord" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false">
        <div class="product-wrapper" id="product_{{product.product_id}}" *ngFor="let product of productList">
            <ul class="product-type" *ngIf="product.price_marked == 1">
                <li >
                    <img
                    src="../../assets/images/pmp.svg" alt="checked icon" />
                </li>
            </ul>
            <div class="product-inner-wrapper">
                <div class="product-image">
                    <a [routerLink]="['/product/detail',product.sku]">
                        <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                    </a>
                </div>
                <div class="product-description">
                    <h2>{{product.short_desc}}</h2>
                    <div class="add-cart-wrapper add_btn_{{product.product_id}}" ng-app="classApp" [ngClass]="product.item_id !== '' ? 'expand' : 'no-expand'" *ngIf="product.item_id == ''">
                        <div id="spinner_{{product.product_id}}" class="spinner">
                            <ngx-number-spinner id="spinerbtn_{{product.product_id}}" [ngClass]="{'spinner':true}" [value]="product.qty !='' ? toInteger(product.qty) : 1" [min]="1" (change)="qytChange(product, $event)">
                            </ngx-number-spinner>
                        </div>
                        <button [ngClass]="{'btn primary-btn':true}" id="btn_{{product.product_id}}" *ngIf="product.item_id == ''" (click)="addToCart(product, product.qty)">Add</button>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
